import $ from 'jquery';

export default class {
    constructor() {
        this.init();
        this.apiUrl = window._env.config.apiUrl;
        this.url = window._env.config.url;
    }

    init() {
        // Handle profile picture uploads and updating thumbnails after upload
        $('#file').change(function (e) {
            let profilePictureUpload = $('#profile-picture-upload');
            const form = profilePictureUpload[0];

            const data = new FormData(form);
            e.preventDefault();
            $('.profile-picture-upload-label').addClass('disabled');
            $.ajax({
                url: '/wp-json/api/v1/upload_profile_picture',
                type: 'POST',
                processData: false,
                contentType: false,
                cache: false,
                beforeSend: function (xhr) {
                    // eslint-disable-next-line no-undef
                    xhr.setRequestHeader('X-WP-Nonce', ajax_object.ajax_nonce);
                },
                data,
            }).done(function (response) {
                const responseObj = JSON.parse(response);
                const profileImageURL = responseObj['profile_image_url'];
                // Update displayed profile images
                $('.profile-img').css('background-image', `url(${profileImageURL}`);
                $('.profile-picture-upload-current').attr('src', profileImageURL);
                $('.profile-picture-upload-label').removeClass('disabled');

                console.log('Profile Image Upload Complete...');

                // reload the page to show the new image
                location.reload();

            }).error(function () {
                $('.profile-picture-upload-label').removeClass('disabled');
            });
        });

        // Handle navigating to the upgrade page after user selects the paid plan
        // in the memberships dropdown
        $('#user-profile-membership').change(function (e) {
            const membershipName = e.target.value;
            if (membershipName === 'Unlimited - Paid') {
                window.location.href = '/upgrade';
            }
        });
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/userProfileSettings.js